import { memo, useState } from "react";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ReminderModal from "../../../modal/reminder";

function ReminderButton({ emailId }) {
  const [showReminderModal, setShowReminderModal] = useState(false);
  return (
    <>
      <span
        style={{
          marginLeft: "20px",
          fontSize: "20px",
          cursor: "pointer",
        }}
        onClick={() => {
          setShowReminderModal(true);
        }}
      >
        <FontAwesomeIcon icon={faBell} />
      </span>
      <ReminderModal
        emailId={emailId}
        setShowReminderModal={setShowReminderModal}
        showReminderModal={showReminderModal}
      />
    </>
  );
}

export default memo(ReminderButton);
